<template>
  <div class="container-fluid">
    <div class="header  mt-4 mt-md-0">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h6 class="header-pretitle">
              결제 정보
            </h6>
            <h1 class="header-title">
              {{ centerAccount.name }}
            </h1>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col">
            <ul class="nav nav-tabs nav-overflow header-tabs">
              <li class="nav-item nav-link active">
                결제 내역
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="payment-plan__container">
      <div class="payment-plan__row">
        <div class="payment-plan__column title">
          현재 이용 중인 플랜
        </div>
        <div class="payment-plan__column">
          {{ presentCurPaymentPlan }}
        </div>
      </div>
      <div class="payment-plan__row">
        <div class="payment-plan__column title">
          {{ centerAccount.plan ? '서비스 종료일' : '무료 이용 기간' }}
        </div>
        <div class="payment-plan__column">
          {{ presentExpirationDate }}
        </div>
      </div>
    </div>

    <el-table
      :data="historyCurrentPageList"
      class="fifl-main-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      row-class-name="fifl-table-row"
      cell-class-name="fifl-main-table-cell"
    >
      <el-table-column
        prop="paid"
        label="결제일"
        :width="tableColWidth.paid"
      >
        <template slot-scope="scope">
          {{ presentDate(scope.row.paid) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="plan"
        label="플랜"
        :width="tableColWidth.plan"
      >
        <template slot-scope="scope">
          {{ presentPaymentPlan(scope.row.plan) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="start"
        label="시작일"
        :width="tableColWidth.start"
      >
        <template slot-scope="scope">
          {{ presentDate(scope.row.start) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="end"
        label="종료일"
        :width="tableColWidth.end"
      >
        <template slot-scope="scope">
          {{ presentDate(scope.row.end) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="비고"
        :width="tableColWidth.description"
        show-overflow-tooltip
      />
      <el-table-column
        prop="price"
        label="정상 금액"
        :width="tableColWidth.price"
      >
        <template slot-scope="scope">
          {{ presentPrice(scope.row.price) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="payment"
        label="결제 금액"
        :width="tableColWidth.payment"
      >
        <template slot-scope="scope">
          {{ presentPrice(scope.row.payment) }}
        </template>
      </el-table-column>
      <div
        slot="empty"
        class="table-empty-container"
        style="min-height: 335px;"
      >
        <warning-message message="결제된 내역이 없습니다." />
      </div>
    </el-table>

    <div style="margin-top: 25px; text-align: center;">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :total="paymentHistories.length"
      />
    </div>
  </div>
</template>

<script>
import WarningMessage from '../components/element-ui/WarningMessage';
import { mapGetters } from 'vuex';
import { numberWithCommas } from '@/utils/etc';
import dateFns from 'date-fns';
import resizePageMixin from '@/mixins/resizePageMixin';
import { fiflboxApi } from '@/utils/api';

const PLAN_NAME = {
  0: '화이트 (무료 플랜)',
  1: '그레이',
  2: '블랙',
  3: '라이트 그레이'
};

const RESPONSIVE_TABLE_WIDTH = {
  mobile: {
    paid: 70,
    plan: 150,
    start: 70,
    end: 70,
    description: 200,
    price: 90,
    payment: 90
  },
  desktop: {
    paid: 70,
    plan: 180,
    start: 70,
    end: 70,
    description: null,
    price: 90,
    payment: 90
  }
};

export default {
  name: 'PaymentPage',
  components: { WarningMessage },
  mixins: [resizePageMixin],
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      tableColWidth: RESPONSIVE_TABLE_WIDTH['desktop'],
      paymentHistories: []
    };
  },
  computed: {
    ...mapGetters({
      centerAccount: 'getCenterAccount'
    }),
    presentExpirationDate() {
      if (this.centerAccount.plan) {
        return this.presentDate(this.centerAccount.expiration_date);
      }
      return `${this.presentDate(this.centerAccount.created)} -
        ${this.presentDate(
          dateFns.subDays(this.centerAccount.expiration_date, 1)
        )}`;
    },
    presentCurPaymentPlan() {
      return PLAN_NAME[this.centerAccount.plan];
    },
    historyCurrentPageList() {
      let startId = (this.currentPage - 1) * this.pageSize;
      let endId = this.currentPage * this.pageSize;

      return this.paymentHistories.slice(startId, endId);
    }
  },
  created() {
    this.syncPaymentHistories();
  },
  methods: {
    presentPaymentPlan(plan) {
      if (plan.is_promotion) {
        return `${PLAN_NAME[plan.plan]} (프로모션)`;
      }

      return (
        `${PLAN_NAME[plan.plan]} ${plan.duration}개월` +
        (plan.is_custom ? ' / 브랜디드 앱' : '')
      );
    },
    presentDate(date) {
      if (!date) {
        return '-';
      }

      return dateFns.format(new Date(date), 'YY.MM.DD');
    },
    presentPrice(price) {
      if (price === 0) {
        return '-';
      }

      return numberWithCommas(price);
    },
    async syncPaymentHistories() {
      const { data } = await fiflboxApi.v1.getPaymentHistories();
      this.paymentHistories = data;
    },
    onResize() {
      this.tableColWidth =
        RESPONSIVE_TABLE_WIDTH[window.innerWidth < 768 ? 'mobile' : 'desktop'];
    }
  }
};
</script>

<style lang="scss">
.payment-plan__container {
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
  background-color: #ffffff;
  padding: 30px 16px;

  margin-bottom: 15px;

  @media screen and (max-width: 768px) {
    padding: 16px;
  }
}

.payment-plan__column {
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: -0.8px;
  color: #4a4a4a;
  display: inline-block;

  &.title {
    width: 130px;
    color: #9b9b9b;
    font-weight: 500;
  }
}
</style>
